<template>
	<section>
		<main class="container mt-12 py-12">
			<div class="row">
				<div class="col mt-24 text-center">
					<h2 class="my-12 py-8">{{ $t('checkin.title') }}</h2>

					<form class="needs-validation" novalidate>
						<div class="row">
							<div class="col mb-20">
								<label for="entername">{{ $t('checkin.login.enterlastname') }}</label>
								<input type="text" class="form-control" id="entername" @focus="show" data-layout="compact" v-model="guestLastName" :placeholder="$t('checkin.login.input-placeholder')" required>
								<div v-if="showError" class="invalided-feedback">{{ $t('checkin.login.error') }}</div>
							</div>
						</div>

						<div class="row pt-3">
							<div class="col-md-3 text-left">
								<a @click.prevent="lastStep" class="btn btn-secondary btn-prev">{{ $t('checkin.cancel') }}</a>
							</div>
							<div class="col-md-6 pt-3 dots">
								<p><span class="dot active"></span> <span class="dot"></span> <span class="dot"></span></p>
							</div>
							<div class="col-md-3 text-right">
								<button @click.prevent="nextStep" class="btn btn-primary btn-next" type="submit">{{ $t('checkin.next') }}</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</main>

	</section>
</template>

<script>

    import axios from 'axios'
    import { mapState } from 'vuex';

    export default {
        props: [],
        data: function () {
            return {
                guestLastName: null,
				showError: false
            }
        },
      computed: {
        ...mapState('settings', ['config']),
      },
	    created() {
		    this.$parent.focusField = false;
		    this.$parent.direction = true;
	    },
        methods: {
          lastStep() {
            this.$parent.focusField = false;
            this.$parent.direction = false;
              this.$parent.guest = null;
              this.$parent.component = 'CheckinStart';
          },
          nextStep() {
            this.$parent.visible = false;
            let isGuestCheck = false;
            let self = this

            // if(!document.querySelector(this.$parent.focusField)) return false;
            // this.guestLastName = document.querySelector(this.$parent.focusField).value;


            // Check by lastname
            axios({
                method: 'get',
                url: this.config.apiUrl + 'findByLastName/'+this.guestLastName,
                withCredentials: true
            }).then(function(response) {
              let responseData = response.data;

              if(responseData.status !='OK') {
                // self.showError = true;
              } else {
                self.showError = false;

                if(responseData.returnValue.length  < 2) {
                  self.$parent.guest = responseData.returnValue[0];
                  self.$parent.component = 'CheckinForm';
                } else {
                  self.$parent.guest = responseData.returnValue;
                  self.$parent.component = 'CheckinMultiLastNames';
                }
                return true;
              }
            });

            // check by company
            axios({
                method: 'get',
                url: this.config.apiUrl + 'findByCompany/'+this.guestLastName,
                withCredentials: true
            }).then(function(response) {
              let responseData = response.data;
              if(responseData.status !='OK') {
                  self.showError = true;
              } else {
                self.showError = false;
                if(responseData.returnValue.length  < 2) {
                  self.$parent.guest = responseData.returnValue[0];
                  self.$parent.component = 'CheckinForm';
                } else {
                  self.$parent.guest = responseData.returnValue;
                  self.$parent.component = 'CheckinMultiLastNames';
                }
              }
            });


          },

	        /** Keyboard Events **/
	        accept(text) {
		       this.$parent.accept(text);
	        },
	        show(e) {
		        this.$parent.show(e);
	        },

	        hide() {
		        this.$parent.hide();
	        },

	        next() {
		        this.$parent.next();
	        },
        },
        components: {
        }
    }
</script>

<style lang="scss">
	.hg-button-space {
		width: 450px !important;
	}
</style>
